import React from "react";
import { Typography, Slider, Checkbox, Row, Col, Input } from "antd";
import {
  EmployeeFollowUpEventQuizStatus,
  AnsweredBy,
  QuizAnsweredBy,
  NotApplicableLabel,
  NotApplicableSuffix,
} from "../common/GeneralConfigurations";
import "./EmployeeFollowUpEventDetailListForm.css";
import AdnTextArea from "../common/adnTextArea/AdnTextArea";

const { Text, Title } = Typography;

const QuizQuestionScaleForm = ({
  quizIsAnsweredBy,
  quizStatusId,
  readonly,
  answeredBy,
  questionText,
  isRequired,
  allowNotApplicable,
  minValue,
  maxValue,
  errorMessage,
  fieldName,
  consultantAnswer,
  consultantAllowNotApplicableAnswer,
  supervisorAnswer,
  supervisorAllowNotApplicableAnswer,
  handleSliderChange,
  onNotApplicable,
  isReadOnly,
  onBlur,
}) => {
  const isNotApplicable = true;

  return (
    <>
      {/* Consultant view or Supervisor view and wating for consultant answer */}
      {quizStatusId ===
        EmployeeFollowUpEventQuizStatus.AwaitsResponseFromConsultant &&
        // (answeredBy === AnsweredBy.Consultant || answeredBy === AnsweredBy.Both) && 
        (
          <div className="quiz-question-person">
            <Row>
              <Col span={12}>
                {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} supervisorAnswer:{supervisorAnswer} minValue:{minValue} maxValue:{maxValue}</p> */}

                <Row className="question-title">
                  <Text type="danger">{isRequired ? "* " : ""}</Text>
                  <AdnTextArea
                    placeholder={questionText}
                    disabled
                    autoSize
                  />
                </Row>

                <p className="quiz-element-margin">
                  <Slider
                    name={fieldName}
                    disabled={isReadOnly(
                      allowNotApplicable === true
                        ? consultantAllowNotApplicableAnswer
                        : false
                    )}
                    min={+minValue}
                    max={+maxValue}
                    defaultValue={
                      consultantAnswer ? consultantAnswer : +minValue
                    }
                    value={consultantAnswer ? consultantAnswer : +minValue}
                    onChange={(e) => handleSliderChange(e, fieldName)}
                  />
                </p>
              </Col>
              <Col span={2}>
                <Input
                  readonly
                  style={{
                    marginTop: "20%",
                    marginLeft: "10%",
                  }}
                  value={consultantAnswer ? consultantAnswer : +minValue}
                  defaultValue={consultantAnswer ? consultantAnswer : +minValue}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {allowNotApplicable === true && (
                  <p className="quiz-element-margin">
                    <Checkbox
                      name={fieldName + NotApplicableSuffix}
                      defaultChecked={consultantAllowNotApplicableAnswer}
                      checked={consultantAllowNotApplicableAnswer}
                      onChange={(value) => onNotApplicable(value, fieldName)}
                      disabled={readonly}
                    >
                      {NotApplicableLabel}
                    </Checkbox>
                  </p>
                )}
                {errorMessage && <Text type="danger">{errorMessage}</Text>}
              </Col>
            </Row>
          </div>
        )}
      {/* Supervisor view for regular type events, that are answered only by the supervisor */}
      {quizIsAnsweredBy === QuizAnsweredBy.Supervisor &&
        quizStatusId ===
        EmployeeFollowUpEventQuizStatus.AwaitsResponseFromSupervisor &&
        (answeredBy === AnsweredBy.Supervisor ||
          answeredBy === AnsweredBy.Both) && (
          <>
            <Row>
              <Col span={12}>
                {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} supervisorAnswer:{supervisorAnswer} minValue:{minValue} maxValue:{maxValue}</p> */}

                <Row className="question-title">
                  <Text type="danger">{isRequired ? "* " : ""}</Text>
                  <AdnTextArea
                    placeholder={questionText}
                    disabled
                    autoSize
                  />
                </Row>

                <p className="quiz-element-margin">
                  <Slider
                    name={fieldName}
                    disabled={isReadOnly(
                      allowNotApplicable === true
                        ? supervisorAllowNotApplicableAnswer
                        : false
                    )}
                    min={+minValue}
                    max={+maxValue}
                    defaultValue={
                      supervisorAnswer ? supervisorAnswer : +minValue
                    }
                    value={supervisorAnswer ? supervisorAnswer : +minValue}
                    onChange={(e) => handleSliderChange(e, fieldName)}
                  />
                </p>
              </Col>
              <Col span={2}>
                <Input
                  readonly
                  style={{
                    marginTop: "20%",
                    marginLeft: "10%",
                  }}
                  value={supervisorAnswer ? supervisorAnswer : +minValue}
                  defaultValue={supervisorAnswer ? supervisorAnswer : +minValue}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {allowNotApplicable === true && (
                  <p className="quiz-element-margin">
                    <Checkbox
                      name={fieldName + NotApplicableSuffix}
                      defaultChecked={supervisorAllowNotApplicableAnswer}
                      checked={supervisorAllowNotApplicableAnswer}
                      onChange={(value) => onNotApplicable(value, fieldName)}
                      disabled={readonly}
                    >
                      {NotApplicableLabel}
                    </Checkbox>
                  </p>
                )}
                {errorMessage && <Text type="danger">{errorMessage}</Text>}
              </Col>
            </Row>
          </>
        )}
      {/* Supervisor view for evaluation type events */}
      {quizIsAnsweredBy === QuizAnsweredBy.Consultant &&
        quizStatusId ===
        EmployeeFollowUpEventQuizStatus.AwaitsResponseFromSupervisor && (
          <>
            {/* consultant answer */}

            <Row className="question-title">
              <Text type="danger">{isRequired ? "* " : ""}</Text>
              <AdnTextArea
                placeholder={questionText}
                disabled
                autoSize
              />
            </Row>

            {allowNotApplicable === true &&
              consultantAllowNotApplicableAnswer === isNotApplicable ? (
              <>
                <b style={{ color: "var(--adnblue)" }}>Consultant:</b>{" "}
                <p className="quiz-not-applicable">{NotApplicableLabel}</p>
              </>
            ) : (
              <p>
                <b style={{ color: "var(--adnblue)" }}>Consultant:</b>{" "}
                {consultantAnswer}
              </p>
            )}
            {/* supervisor answer */}
            {(answeredBy === AnsweredBy.Supervisor ||
              answeredBy === AnsweredBy.Both) && (
                <div className="quiz-question-person">
                  <Row>
                    <Col span={12}>
                      {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} supervisorAnswer:{supervisorAnswer} minValue:{minValue} maxValue:{maxValue}</p> */}

                      <Row className="question-title">
                        <Text type="danger">{isRequired ? "* " : ""}</Text>
                        <AdnTextArea
                          placeholder={questionText}
                          disabled
                          autoSize
                        />
                      </Row>

                      <p className="quiz-element-margin">
                        <Slider
                          name={fieldName}
                          disabled={isReadOnly(
                            allowNotApplicable === true
                              ? supervisorAllowNotApplicableAnswer
                              : false
                          )}
                          min={+minValue}
                          max={+maxValue}
                          defaultValue={
                            supervisorAnswer ? supervisorAnswer : +minValue
                          }
                          value={supervisorAnswer ? supervisorAnswer : +minValue}
                          onChange={(e) => handleSliderChange(e, fieldName)}
                          onBlur={onBlur}
                        />
                      </p>
                    </Col>
                    <Col span={2}>
                      <Input
                        readonly
                        style={{
                          marginTop: "20%",
                          marginLeft: "10%",
                        }}
                        value={supervisorAnswer ? supervisorAnswer : +minValue}
                        defaultValue={
                          supervisorAnswer ? supervisorAnswer : +minValue
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {allowNotApplicable === true && (
                        <p className="quiz-element-margin">
                          <Checkbox
                            name={fieldName + NotApplicableSuffix}
                            defaultChecked={supervisorAllowNotApplicableAnswer}
                            checked={supervisorAllowNotApplicableAnswer}
                            onChange={(value) =>
                              onNotApplicable(value, fieldName)
                            }
                            disabled={readonly}
                          >
                            {NotApplicableLabel}
                          </Checkbox>
                        </p>
                      )}
                      {errorMessage && <Text type="danger">{errorMessage}</Text>}
                    </Col>
                  </Row>
                </div>
              )}
          </>
        )}
      {/* when quiz is answered */}
      {quizStatusId === EmployeeFollowUpEventQuizStatus.Answered && (
        <>
          {/* consultant answer */}
          <Row className="question-title">
            <Text type="danger">{isRequired ? "* " : ""}</Text>
            <AdnTextArea
              placeholder={questionText}
              disabled
              autoSize
            />
          </Row>

          {(consultantAnswer || consultantAllowNotApplicableAnswer) && (
            <p>
              <span code strong className="answer-consultant">
                Consultant:{" "}
              </span>
              {consultantAnswer > 0 && <Text>{consultantAnswer}</Text>}
              {consultantAllowNotApplicableAnswer === isNotApplicable && (
                <Text type="warning" className="quiz-not-applicable">
                  {NotApplicableLabel}
                </Text>
              )}
            </p>
          )}
          {/* supervisor answer */}
          {(supervisorAnswer || supervisorAllowNotApplicableAnswer) && (
            <p>
              <span className="answer-supervisor">Supervisor: </span>
              {supervisorAnswer > 0 && <Text>{supervisorAnswer}</Text>}
              {supervisorAllowNotApplicableAnswer === isNotApplicable && (
                <Text type="warning" className="quiz-not-applicable">
                  {NotApplicableLabel}
                </Text>
              )}
            </p>
          )}
        </>
      )}
    </>
  );
};

export default QuizQuestionScaleForm;
